import { mapGetters, mapActions } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import relatoriosPesquisaSatisfacaoStore from '../store'

export const relatoriosPesquisaSatisfacaoMixins = {
  data: () => ({
    showSkeletonForm: false,
    showSkeletonReport: false,
    canShowReport: false,
    pesquisas: [],
    tags: [],
  }),

  computed: {
    ...mapGetters('relatoriosPesquisaSatisfacaoStore', ['getPesquisasSatisfacao', 'getTags']),

    todasPesquisasSelecionadas() {
      return this.form.pesquisas.length === this.pesquisas.length
    },
    algumasPesquisasSelecionadas() {
      return this.form.pesquisas.length > 0 && !this.todasPesquisasSelecionadas
    },
    iconPesquisas() {
      if (this.todasPesquisasSelecionadas) return 'mdi-close-box'
      if (this.algumasPesquisasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    todasTagsSelecionadas() {
      return this.form.tags.length === this.tags.length
    },
    algumasTagsSelecionadas() {
      return this.form.tags.length > 0 && !this.todasTagsSelecionadas
    },
    iconTags() {
      if (this.todasTagsSelecionadas) return 'mdi-close-box'
      if (this.algumasTagsSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    registerVuexModule(this.$store, 'relatoriosPesquisaSatisfacaoStore', relatoriosPesquisaSatisfacaoStore)
  },

  methods: {
    ...mapActions('relatoriosPesquisaSatisfacaoStore', ['listarPesquisasSatisfacao', 'listarTags']),

    togglePesquisas() {
      this.$nextTick(() => {
        if (this.todasPesquisasSelecionadas) {
          this.form.pesquisas.splice(0)
        } else {
          this.form.pesquisas.splice(0)
          this.form.pesquisas = this.pesquisas.map(pesquisa => pesquisa.value)
        }
      })
    },
    toggleTags() {
      this.$nextTick(() => {
        if (this.todasTagsSelecionadas) {
          this.form.tags.splice(0)
        } else {
          this.form.tags.splice(0)
          this.form.tags = this.tags.map(tag => tag.value)
        }
      })
    },
  },
}
